import React from "react";
import classnames from "classnames";

const SPR25_SMT_PRINTER_DESCRIPTION = 'The Gold-Print&#153; SPR-25 benchtop manual SMT stencil printer is designed for low to medium volume surface mount prototype printed circuit board assembly runs.' 

const getDescription = (product_slug, description) => {
  switch(product_slug){
    case 'spr-25-manual-smt-stencil-printer':
      return SPR25_SMT_PRINTER_DESCRIPTION;
    default:
      return description;
  }
}

const Description = ({product_slug, description, inputClassName}) => {

  return (
    <div className={classnames("description-block", inputClassName)} 
      dangerouslySetInnerHTML={{ __html: `<p>${getDescription(product_slug, description)}</p>` }}/>
  )
}

export default Description;

